import Axios, { InternalAxiosRequestConfig } from "axios"
import { toast } from "sonner"

import { env } from "@/config/env"
import { refreshToken } from "@/features/auth/api/refresh-token"
import { Cookie } from "@/utils/storage"

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = "application/json"
  }

  const token = Cookie.getAccessToken()
  if (token) {
    config.headers.authorization = `Bearer ${token}`
  }

  return config
}

export const api = Axios.create({
  baseURL: `${env.API_URL}/${env.API_VERSION}`,
})

api.interceptors.request.use(authRequestInterceptor)
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (error) => {
    // refresh token
    const originalRequest = error?.config
    if (
      error?.response &&
      error?.response?.status === 401 &&
      !originalRequest?._retry
    ) {
      originalRequest._retry = true

      try {
        const refreshTokenPromise = refreshToken({
          refresh_token: Cookie.getRefreshToken() || "",
        })

        const { data } = await refreshTokenPromise
        const { access_token, refresh_token } = data

        Cookie.setAccessToken(access_token)
        Cookie.setRefreshToken(refresh_token)

        originalRequest.headers.authorization = `Bearer ${access_token}`

        return api(originalRequest)
      } catch (error) {
        Cookie.clearTokens()
        return Promise.reject(error)
      }
    }

    const message =
      error?.response?.data?.data?.message ||
      error?.response?.data?.data?.error?.message ||
      error?.response?.data?.message ||
      error?.message

    if (
      message !== "The refresh token field is required." &&
      message !== "Refresh Token Tidak Valid"
    ) {
      toast.error(message)
    }

    return Promise.reject(error)
  }
)
